export const samples = [
  {
    id: 1,
    title: 'Micro Edition - Week 1',
    edition: 'micro',
    pdfUrl: '/samples/micro-week-1.pdf', // or .pdf when available
    thumbnail: null,
    fileName: 'micro-week-1.pdf',
    fileSize: null,
    uploadDate: '2024-01-15',
    description: 'Featuring the story "The Brave Little Turtle" plus fun puzzles and coloring activities!',
  },
  {
    id: 2,
    title: 'Micro Edition - Week 2',
    edition: 'micro',
    pdfUrl: '/samples/micro-week-2.pdf',
    thumbnail: null,
    fileName: 'micro-week-2.pdf',
    fileSize: null,
    uploadDate: '2024-01-22',
    description: 'Coming soon! Stories about friendship and fun math games.',
  },
  {
    id: 3,
    title: 'Macro Edition - Week 1',
    edition: 'macro',
    pdfUrl: '/samples/macro-week-1.pdf', // or .pdf when available
    thumbnail: null,
    fileName: 'macro-week-1.pdf',
    fileSize: null,
    uploadDate: '2024-01-15',
    description: 'Young innovators spotlight, brain teasers, and creative writing prompts!',
  },
  {
    id: 4,
    title: 'Macro Edition - Week 2',
    edition: 'macro',
    pdfUrl: '/samples/macro-week-2.pdf',
    thumbnail: null,
    fileName: 'macro-week-2.pdf',
    fileSize: null,
    uploadDate: '2024-01-22',
    description: 'Coming soon! Science experiments and world geography features.',
  },
];